import { ADD_MESSAGE } from '../actionTypes';
import { commentAreaActions } from '../reducer';

export default (values) => commentAreaActions[ADD_MESSAGE](values);
